import React from "react";

import { resultsLabel } from "../accessoryCopy";

const ResultsBar = ({ total, loading, activeCount, sortLabel, onClear }) => (
  <div className="acc-results-bar">
    <p className="acc-results-count" role="status" aria-live="polite">
      {loading ? (
        <span className="acc-shimmer acc-shimmer-line acc-shimmer-count" />
      ) : (
        <>
          {resultsLabel(total)}
          {sortLabel && <i className="acc-results-sort"> · {sortLabel}</i>}
        </>
      )}
    </p>

    {activeCount > 0 && (
      <button type="button" className="acc-clear-filters" onClick={onClear}>
        Clear filters
      </button>
    )}
  </div>
);

export default ResultsBar;
